var map = {
	"./01_hero_desktop.jpg": 737,
	"./01_hero_mobile.jpg": 738,
	"./01_hero_tablet.jpg": 739,
	"./01_twitter_image.jpg": 740,
	"./02_hero_desktop.jpg": 741,
	"./02_hero_mobile.jpg": 742,
	"./02_hero_tablet.jpg": 743,
	"./02_twitter_image.jpg": 744,
	"./03_hero_desktop.jpg": 745,
	"./03_hero_mobile.jpg": 746,
	"./03_hero_tablet.jpg": 747,
	"./03_twitter_image.jpg": 748,
	"./04_hero_desktop.jpg": 749,
	"./04_twitter_image.jpg": 750,
	"./05_hero_desktop.jpg": 751,
	"./05_twitter_image.jpg": 752,
	"./06_hero_desktop.jpg": 753,
	"./06_twitter_image.jpg": 754,
	"./07_hero_desktop.jpg": 755,
	"./07_twitter_image.jpg": 756,
	"./08_hero_desktop.jpg": 757,
	"./08_twitter_image.jpg": 758,
	"./09_hero_desktop.jpg": 759,
	"./09_twitter_image.jpg": 760,
	"./10_hero_desktop.jpg": 761,
	"./10_twitter_image.jpg": 762,
	"./11_hero_desktop.jpg": 763,
	"./11_twitter_image.jpg": 764,
	"./12_the-urban-farm-sending-meals-to-children.jpg": 765,
	"./12_the-urban-farm-sending-meals-to-children_twitter_image.jpg": 766,
	"./22_hero_desktop.jpg": 767,
	"./22_twitter_image.jpg": 768,
	"./2ATH3BK.crop-twitter.jpg": 769,
	"./2ATH3BK.crop.jpg": 770,
	"./ABENT3.crop-twitter.jpg": 771,
	"./ABENT3.crop.jpg": 772,
	"./James-wong-hero.jpg": 773,
	"./James-wong-twitter.jpg": 774,
	"./LNC-aggregates-on-sand-2-crop.jpg": 775,
	"./Seawatergreenhouseaus_crop.jpg": 776,
	"./Seawatergreenhouseaus_crop_twitter.jpg": 777,
	"./Thought-leaders-hero.jpg": 778,
	"./Thought-leaders-twitter.jpg": 779,
	"./africa_getty.jpg": 780,
	"./africa_getty_twitter.jpg": 781,
	"./cattle-drones-twitter.jpg": 782,
	"./cattle-drones_hero.jpg": 783,
	"./food-chain_hero_desktop.jpg": 784,
	"./food_chain_twitter_image.jpg": 785,
	"./how-covid-19-is-changing-food-shopping-twitter-image.jpg": 786,
	"./how-covid-19-is-changing-food-shopping.jpg": 787,
	"./how-we-can-adapt-plants-to-save-our-planet-hero.jpg": 788,
	"./how-we-can-adapt-plants-to-save-our-planet-twitter.jpg": 789,
	"./kiwi-picker-robotics-twitter.jpg": 790,
	"./kiwi-picker-robotics.jpg": 791,
	"./the-freedom-soup-twitter.jpg": 792,
	"./the-freedom-soup.jpg": 793,
	"./the-green-milk-made-from-cells-twitter.jpg": 794,
	"./the-green-milk-made-from-cells.jpg": 795,
	"./the-massive-farms-emerging-beneath-our-cities.jpg": 796,
	"./the-massive-farms-emerging-beneath-our-cities_twitter_image.jpg": 797,
	"./the-simple-shellfish-that-fights-climate-change_hero.jpg": 798,
	"./the-simple-shellfish-that-fights-climate-change_twitter.jpg": 799,
	"./the_invisible_women_article.jpg": 800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 440;